var _path, _rect, _path2, _rect2, _path3, _rect3, _rect4, _g, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 522,
    viewBox: "0 0 435 522",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.425 0L435 115H38V0H322.425Z",
    fill: "#FAFAFD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 115,
    width: 397,
    height: 407,
    fill: "#FAFAFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M322.5 115H435L322.5 0V115Z",
    fill: "#DEE2E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 115,
    width: 97,
    height: 16,
    fill: "#E9ECEF",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.323 123C135.027 172.113 170.627 224.708 214.5 279.291C275.856 355.627 338.19 411.736 396 452.359V459.791C396 477.464 381.673 491.791 364 491.791H110C92.3269 491.791 78 477.464 78 459.791V154.791C78 138.361 90.3819 124.824 106.323 123Z",
    fill: "#E9ECEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 278,
    height: 111,
    fill: "#E76F00"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 131,
    width: 218,
    height: 31,
    fill: "#E9ECEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_106_479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.5724 41.1818H93.1179V90.2727C93.0952 94.7727 92.1406 98.6477 90.2543 101.898C88.3679 105.125 85.7315 107.614 82.3452 109.364C78.9815 111.091 75.0611 111.955 70.5838 111.955C66.4929 111.955 62.8111 111.227 59.5384 109.773C56.2884 108.295 53.7088 106.114 51.7997 103.227C49.8906 100.341 48.9361 96.75 48.9361 92.4545H61.5156C61.5384 94.3409 61.9474 95.9659 62.7429 97.3295C63.5611 98.6932 64.6861 99.7386 66.1179 100.466C67.5497 101.193 69.1974 101.557 71.0611 101.557C73.0838 101.557 74.7997 101.136 76.2088 100.295C77.6179 99.4318 78.6861 98.1591 79.4134 96.4773C80.1634 94.7955 80.5497 92.7273 80.5724 90.2727V41.1818ZM115.805 111H102.305L126.885 41.1818H142.499L167.112 111H153.612L134.964 55.5H134.419L115.805 111ZM116.249 83.625H153.067V93.7841H116.249V83.625ZM176.308 111V41.1818H202.49C207.854 41.1818 212.354 42.1136 215.99 43.9773C219.649 45.8409 222.411 48.4545 224.274 51.8182C226.161 55.1591 227.104 59.0568 227.104 63.5114C227.104 67.9886 226.149 71.875 224.24 75.1705C222.354 78.4432 219.57 80.9773 215.888 82.7727C212.206 84.5455 207.683 85.4318 202.32 85.4318H183.672V74.9318H200.615C203.751 74.9318 206.32 74.5 208.32 73.6364C210.32 72.75 211.797 71.4659 212.751 69.7841C213.729 68.0795 214.217 65.9886 214.217 63.5114C214.217 61.0341 213.729 58.9205 212.751 57.1705C211.774 55.3977 210.286 54.0568 208.286 53.1477C206.286 52.2159 203.706 51.75 200.547 51.75H188.956V111H176.308ZM212.376 79.3636L229.661 111H215.547L198.57 79.3636H212.376Z",
    fill: "#FAFAFD"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M197.256 401.005C197.256 401.005 185.792 407.672 205.415 409.928C229.188 412.64 241.338 412.251 267.535 407.293C267.535 407.293 274.423 411.612 284.042 415.352C225.314 440.522 151.128 413.894 197.256 401.005ZM190.08 368.16C190.08 368.16 177.222 377.678 196.859 379.709C222.254 382.329 242.309 382.543 277.011 375.861C277.011 375.861 281.812 380.727 289.359 383.388C218.352 404.152 139.264 385.026 190.08 368.16",
    fill: "#5382A1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M250.581 312.444C265.052 329.104 246.78 344.097 246.78 344.097C246.78 344.097 283.522 325.129 266.648 301.377C250.888 279.225 238.802 268.22 304.231 230.273C304.232 230.273 201.528 255.923 250.581 312.444",
    fill: "#E76F00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M328.253 425.3C328.253 425.3 336.737 432.291 318.91 437.698C285.011 447.967 177.82 451.068 148.042 438.108C137.338 433.45 157.411 426.988 163.726 425.632C170.311 424.204 174.074 424.47 174.074 424.47C162.17 416.084 97.1305 440.936 141.037 448.054C260.777 467.472 359.313 439.309 328.253 425.3V425.3ZM202.771 334.129C202.771 334.129 148.247 347.079 183.463 351.782C198.332 353.773 227.974 353.322 255.583 351.009C278.148 349.106 300.806 345.059 300.806 345.059C300.806 345.059 292.85 348.467 287.093 352.397C231.725 366.959 124.763 360.184 155.556 345.289C181.597 332.701 202.771 334.129 202.771 334.129V334.129ZM300.581 388.801C356.866 359.554 330.843 331.446 312.678 335.233C308.226 336.16 306.241 336.963 306.241 336.963C306.241 336.963 307.894 334.374 311.05 333.253C346.984 320.62 374.621 370.514 299.449 390.276C299.449 390.276 300.322 389.498 300.581 388.801Z",
    fill: "#5382A1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M266.648 169C266.648 169 297.819 200.181 237.083 248.131C188.379 286.593 225.977 308.524 237.063 333.582C208.634 307.931 187.771 285.351 201.768 264.336C222.311 233.487 279.225 218.531 266.648 169",
    fill: "#E76F00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M208.301 468.056C262.327 471.514 345.291 466.137 347.255 440.574C347.255 440.574 343.479 450.264 302.605 457.961C256.493 466.639 199.619 465.626 165.887 460.065C165.888 460.063 172.793 465.779 208.301 468.056",
    fill: "#5382A1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_106_479",
    x: 36.9375,
    y: 41.1836,
    width: 196.723,
    height: 86.7695,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_106_479"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_106_479",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJar);
export default __webpack_public_path__ + "static/media/jar.f7118ae8d2764e9584ea63b326eccf0f.svg";
export { ForwardRef as ReactComponent };